<template>
	<q-tr :key="logId" :props="props">
		<q-td key="place" :props="props">{{ place }}</q-td>
		<q-td key="name" :props="props">{{ palletNo }}</q-td>
		<q-td key="species" :props="props">{{ speciesName }}</q-td>
		<q-td key="palletArea" :props="props">{{ palletArea | number(userLocale) }}</q-td>
		<q-td key="palletResultAreaNotRemeasured" :props="props">{{ resultAreaNotRemeasured | number(userLocale) }}</q-td>
		<q-td key="inPalletPercentage" :props="props">{{ (resultAreaNotRemeasured / palletArea) * 100 | number(userLocale, 0, 0) }}%</q-td>
		<q-td key="palletResultArea" :props="props">{{ resultAreaMeasuredBack | number(userLocale) }}</q-td>
		<q-td key="percentageArea" :props="props">{{ (resultAreaMeasuredBack / resultAreaNotRemeasured) * 100 | number(userLocale, 0, 0) }}%</q-td>
		<q-td key="maxLength" :props="props">{{ maxLength | number(userLocale) }}</q-td>
		<q-td key="bundleCount" :props="props">{{ bundleCount }}</q-td>
		<q-td key="palletInfo" :props="props">{{ palletInfo }}</q-td>
		<q-td key="palletInfoInternal" :props="props">{{ palletInfoInternal }}</q-td>
		<q-td key="actions" :props="props">
			<q-btn color="primary"
				   v-if="user"
				   @click="$emit('showPalletLogList', pallet)"
				   icon="launch"
				   dense
			>
				<q-tooltip>{{ $t('button.palletLogs') }}</q-tooltip>
			</q-btn>
		</q-td>
	</q-tr>
</template>

<script>
	import LogPropertiesResolver from "@/mixins/LogPropertiesResolver";
	import NumberFormattingFilters from "@/mixins/NumberFormattingFilters";
	import {mapGetters} from "vuex";

	export default {
		name: "PalletTableRow",
		mixins: [LogPropertiesResolver, NumberFormattingFilters],
		props: ['props'],
		computed: {
			...mapGetters(['user']),
			pallet() {
				return this.props.row;
			}
		}
	}
</script>

<style scoped>

</style>